module.exports = __webpack_public_path__ + "static/img/ticketplus-logo.9b15cd66.svg";